import React from 'react'
import { region, change } from '../../../store/actions/metrics.action'
import { CircularProgress, TextField, AppBar, Toolbar, IconButton, Typography, CardHeader, Avatar } from '@material-ui/core'
import { FcFilingCabinet} from 'react-icons/fc'
import { MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import VerifySms from '../../components/VerifySms'

export default function Metrics(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.uid) ? props.uid : null;
    const link_id = (props.link_id) ? props.link_id : null;

    const { open, screen_id } = useSelector(state => state.smsReducer)
    const { data } = useSelector(state => state.metricsReducer)

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)
    const [visible, setVisible] = React.useState(false);

    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState();
    const [dateFinal, setDateFinal] = React.useState(dateEnd);

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        _index()
    }, [dateInitial, dateFinal])

    const _index = () => {
        setLoad(true)
        dispatch(region(campaign_id, link_id, new Date(dateInitial), new Date(dateFinal))).then(() => {
            setLoad(false)
            setLoading(false)
        })
    }

    const _handleVisible = () => {
        setVisible(!visible)
    }

    return (
        <>
            <VerifySms 
                type="login_code"
                open={screen_id === 'metrics.index' && open}
                onConfirm={() => {
                    _index()
                }}
                onClose={() => window.location.replace('/')}
            />

            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => link_id ? dispatch(changeScreenB({ open: false })) : dispatch(changeScreen({ open: false })) } edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6">
                            Gasto por Região
                        </Typography>
                    </Toolbar>
                </AppBar>
                
                {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                <div className="card p-3 mt-3 mb-2 bs-bg">
                    <div className="row mt-2">
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Inicial"
                                    type="datetime-local"
                                    value={dateInitial}
                                    defaultValue={dateInit}
                                    InputLabelProps={{
                                        shrink: dateInitial ? true : false,
                                    }}
                                    onBlur={e => setDateInitial(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Final"
                                    type="datetime-local"
                                    value={dateFinal}
                                    defaultValue={dateEnd}
                                    InputLabelProps={{
                                        shrink: dateFinal ? true : false,
                                    }}
                                    onBlur={e => {
                                        if(e.target.value) {
                                            setDateFinal(e.target.value)
                                        } else {
                                            setDateFinal(dateEnd)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                    <>
                        {(data.length < 1) &&
                            <div className="card card-body mt-3 bs-bg">
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <FcFilingCabinet size="70" />
                                    <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                                </div>
                            </div>
                        }

                        {(data.length > 0) &&
                            <>
                                {data.map((item, index) => (
                                    <div className="card pointer bs-bg list-items mb-3" key={index}>
                                        <CardHeader 
                                            avatar={
                                                <Avatar className="avatar-item">
                                                    <span className="fw-bold">{index + 1}</span>
                                                </Avatar>
                                            }
                                            title={<h5 className="fw-bold bs-color-b">{item.estado}</h5>}
                                            subheader={<>
                                                <span className="d-block bs-color">{item.regiao}</span>
                                                
                                                <div className="row mt-3">
                                                    <div className="col">
                                                        <label className="fw-normal label-custom bs-color mb-1">Porcentagem</label>
                                                        
                                                        <span className="fw-bold bs-color-b d-block">{item.percent.toLocaleString('pt-BR', {style: 'decimal'})}%</span>
                                                    </div>

                                                    <div className="col">
                                                        <label className="fw-normal label-custom bs-color mb-1">Transações</label>
                                                        
                                                        <span className="fw-bold bs-color-b d-block">{item.transactions.toLocaleString('pt-BR', {style: 'decimal'})}</span>
                                                    </div>
                                                    
                                                    <div className="col">
                                                        {visible &&
                                                            <>
                                                            <label className="fw-normal label-custom bs-color mb-1">Valor bruto</label>
                                                            
                                                            <span className="fw-bold bs-color-b d-block">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.amount)}</span>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </>}
                                        />
                                    </div>
                                ))}
                            </>
                        }

                    </>
                }
                </>
                }
            </div>
        </>
    )
}